export const removeNode = ({ node, pos, tr, dispatch }) => {
    dispatch(tr.delete(pos, pos + node.nodeSize));
};
